
import Previous from "../../../assets/filled/Previous.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PreviousIcon({ className, dataTestid = "PreviousIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Previous data-testid={dataTestid} className={classes} {...rest} />
  );
}
